import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-donation-campaign-admin',
  templateUrl: './donation-campaign-admin.component.html',
  styleUrls: ['./donation-campaign-admin.component.css']
})
export class DonationCampaignAdminComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
